import { HttpInterceptorFn } from '@angular/common/http';

import { XSRF_HEADER_NAME } from 'app/constants';
import { getCookie } from 'app/helpers';
import { environment } from 'environments/environment';

const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
    if (!MUTATING_METHODS.has(req.method)) {
        return next(req);
    }

    const token = getCookie(environment.xsrfCookieName);

    if (!token) {
        return next(req);
    }

    return next(req.clone({ setHeaders: { [XSRF_HEADER_NAME]: token } }));
};
